import React from 'react'

export default function Education() {
    return (
        <>
            <div className="border border-stone-800/90 p-[0.4rem] rounded-lg">
                <section className="relative w-full flex flex-col justify-start gap-0">
                    <div
                        className="rounded-lg px-4 py-2 ease-in duration-200 no-underline"
                        data-index="1"
                    >
                        <div className="w-full h-full">
                            <div className="m-0 font-semibold eduheder mb-1">
                                National Institute of Technology, Kurukshetra
                            </div>
                            <div className="flex align-center gap-1 flex-col">
                                <span className="text-zinc-300 m-0">Masters in Cyber Security</span>
                                <span className="text-zinc-300 m-0">Grade: 7.7639</span>
                                <span className="text-zinc-300 text-xs m-0">August 12, 2024 - Present</span>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <br></br>
            <div className="border border-stone-800/90 p-[0.4rem] rounded-lg">
                <section className="relative w-full flex flex-col justify-start gap-0">
                    <div
                        className="rounded-lg px-4 py-2 ease-in duration-200 no-underline"
                        data-index="1"
                    >
                        <div className="w-full h-full">
                            <div className="m-0 font-semibold eduheder mb-1">
                                Government College of Engineering and Ceramic Technology, Kolkata
                            </div>
                            <div className="flex align-center gap-1 flex-col">
                                <span className="text-zinc-300 m-0">Bachelors in Computer Science and Engineering</span>
                                <span className="text-zinc-300 m-0">Grade: 9.6</span>
                                <span className="text-zinc-300 text-xs m-0">August 1, 2020 - July 31, 2024</span>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <br></br>
            <div className="border border-stone-800/90 p-[0.4rem] rounded-lg">
                <section className="relative w-full flex flex-col justify-start gap-0">
                    <div
                        className="rounded-lg px-4 py-2 ease-in duration-200 no-underline"
                        data-index="1"
                    >
                        <div className="w-full h-full">
                            <div className="m-0 font-semibold eduheder mb-1">
                                Hem Sheela Model School, Durgapur
                            </div>
                            <div className="flex align-center gap-1 flex-col">
                                <span className="text-zinc-300 m-0">Higher Secondary</span>
                                <span className="text-zinc-300 m-0">Grade: 94%</span>
                                <span className="text-zinc-300 text-xs m-0">April 31, 2020</span>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <br></br>
            <div className="border border-stone-800/90 p-[0.4rem] rounded-lg">
                <section className="relative w-full flex flex-col justify-start gap-0">
                    <div
                        className="rounded-lg px-4 py-2 ease-in duration-200 no-underline"
                        data-index="1"
                    >
                        <div className="w-full h-full">
                            <div className="m-0 font-semibold eduheder mb-1">
                                Hem Sheela Model School, Durgapur
                            </div>
                            <div className="flex align-center gap-1 flex-col">
                                <span className="text-zinc-300 m-0">Secondary</span>
                                <span className="text-zinc-300 m-0">Grade: 93.8%</span>
                                <span className="text-zinc-300 text-xs m-0">April 31, 2018</span>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}
